import * as React from "react";
import { Button, FormGroup, FormLabel, FormControl, Spinner } from "react-bootstrap";
import { useState } from "react";

import { Report } from "Stores/reportStore";
import { EAIClient } from "Services/EAIClient";
import { useAppContext } from "@/contexts/app";

export interface ReportDetailProps {
    report: Report
    canEdit: boolean
    isEdit: boolean
    onEditDone?: (updatedReport: Report) => void
    onCancel?: () => void
}

export default function ReportDetails(props: ReportDetailProps) {
    const { report, canEdit, isEdit: initialEdit, onEditDone, onCancel } = props;
    const [isEdit, setIsEdit] = useState(initialEdit);
    const [isSaving, setIsSaving] = useState(false);
    const [reportName, setReportName] = useState(report.name);
    const [reportSummary, setReportSummary] = useState(report.summary);
    const eaiClient = new EAIClient();
    const appContext = useAppContext();

    const saveReport = async () => {
        setIsSaving(true);
        try {
            await eaiClient.updateReport(report.id, reportName, reportSummary);

            const updatedReport: Report = {
                ...report,
                name: reportName,
                summary: reportSummary
            };

            if (onEditDone) {
                onEditDone(updatedReport);
            }
            await eaiClient.forceGenerate(report.id);
        } catch (e) {
            appContext.dispatchError(e);
        } finally {
            setIsSaving(false);
            setIsEdit(false);
        }
    };

    const editReport = () => {
        setIsEdit(true);
    };

    const cancelEdit = () => {
        setIsEdit(false);

        if (onCancel) {
            onCancel();
        }
    };

    const renderActions = () => {
        if (isEdit) {
            return (
                <div>
                    <Button size="lg" variant="secondary" onClick={cancelEdit} disabled={isSaving}>
                        Cancel
                    </Button>
                    <Button size="lg" variant="primary" onClick={saveReport} disabled={isSaving}
                        style={{ minWidth: 113 }}>
                        {isSaving ? <Spinner animation="border" /> : "Save"}
                    </Button>
                </div>
            );
        } else {
            return (
                <Button
                    size="lg"
                    variant="secondary"
                    disabled={!canEdit}
                    onClick={editReport}
                >
                    Edit
                </Button>
            );
        }
    };

    return (
        <div className="report-form edit preview">
            <div className="header edit">
                <span>Report Details</span>
                <div className="right">Total ActionPlans Selected: {report.tickets.length}</div>
            </div>
            <div className="body">
                <form>
                    <div className="row">
                        <div className="col-md-5">
                            <FormGroup controlId="report-name">
                                <FormLabel>Report Name</FormLabel>
                                <FormControl
                                    type="text"
                                    value={reportName}
                                    placeholder="Enter name"
                                    disabled={!isEdit}
                                    onChange={(e) => setReportName(e.target.value)}
                                />
                            </FormGroup>
                            <FormGroup controlId="report-summary">
                                <FormLabel>Summary Statement</FormLabel>
                                <FormControl
                                    as="textarea"
                                    value={reportSummary}
                                    placeholder="Enter summary"
                                    disabled={!isEdit}
                                    onChange={(e) => setReportSummary(e.target.value)}
                                />
                            </FormGroup>
                        </div>
                        <div className="actions text-end">
                            {renderActions()}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
